import { render } from "./BankAccountOwnerDataPage.vue?vue&type=template&id=751446ba&scoped=true"
import script from "./BankAccountOwnerDataPage.vue?vue&type=script&lang=js"
export * from "./BankAccountOwnerDataPage.vue?vue&type=script&lang=js"

import "./BankAccountOwnerDataPage.vue?vue&type=style&index=0&id=751446ba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751446ba"]])

export default __exports__